import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ADMIN } from "../../constants/testIds";

export const LiveListenerTracker = ({ releases }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchLive = () => api.get("/admin/presence/live").then(({ data }) => setRows(data)).catch(() => setRows([]));
    fetchLive();
    const interval = setInterval(fetchLive, 15000);
    return () => clearInterval(interval);
  }, []);

  const slugToTitle = (slug) => releases.find((r) => r.slug === slug)?.title || slug;
  const total = rows.reduce((s, r) => s + r.count, 0);

  return (
    <div className="p-5 sm:p-6 rounded-xl border border-slate-800 bg-slate-900/80 backdrop-blur-md">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-200" style={{ fontFamily: "'Outfit', sans-serif" }}>Live Listeners</h3>
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs font-mono animate-pulse">
          {total} now
        </span>
      </div>
      <div data-testid={ADMIN.liveListenerCounter} className="space-y-2">
        {rows.length === 0 && <p className="text-sm text-slate-500">No one listening right now.</p>}
        {rows.map((r) => (
          <div key={r.release_slug} className="flex items-center justify-between text-sm border-b border-white/5 py-2">
            <span className="text-slate-300">{slugToTitle(r.release_slug)}</span>
            <span className="text-emerald-400 font-mono">{r.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
